import { Injectable } from '@angular/core';
import {Surface} from "../../surface/primitives/surface";
import {Assets} from "pixi.js";
import * as PIXI from "pixi.js";
import {EventsBlueprint} from "./events-blueprint";
import {SurfaceService} from "../../surface/surface.service";

@Injectable({
  providedIn: 'root'
})
export class SurfaceGridTestService extends EventsBlueprint {

  override prompt = "surface-grid"

  constructor(
      private surfaceService: SurfaceService
  ) {
    super()
  }

  async start() {
    await this.makeSurfaces()
  }

  surfaces: Surface[] = []

  async makeSurfaces() {
    for (let i = 0; i < 100; i++) {
      for (let j = 0; j < 100; j++) {
        this.surfaces.push(await this.makeSurface(i * 5, j * 5))
      }
    }
  }

  async makeSurface(posx, posy) {
    const surface = await this.surfaceService.create({
      left: posx,
      width: 499,
      top: posy,
      height: 499
    })
    const texture = await Assets.load("https://i.imgur.com/IgIkXoe.jpeg")
    const sprite = new PIXI.Sprite(texture)
    sprite.width = 500
    sprite.height = 500
    surface.stage.addChild(sprite)
    // surface.mesh.position.z = Math.random() * 100
    surface.markForRender()
    return surface
  }
}
